import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { TeamProvider } from './lib/teamContext';
import './index.css';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('[SCENEFORGE] #root element missing from index.html');
}

createRoot(rootEl).render(
  <StrictMode>
    <BrowserRouter>
      <TeamProvider>
        <App />
      </TeamProvider>
    </BrowserRouter>
  </StrictMode>,
);
